import type { ReactNode } from 'react';
import { ChevronRightIcon } from '@/shared/ui/icons';
import { cn } from '@/shared/utils/cn';

type Props = {
  icon: ReactNode;
  label: string;
  value?: string;
  trailing?: ReactNode;
  showChevron?: boolean;
  danger?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export const FeaturesSettingsSettingsRow = ({
  icon,
  label,
  value,
  trailing,
  showChevron = true,
  danger = false,
  disabled = false,
  onClick,
}: Props) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={cn(
      'flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors',
      'disabled:cursor-not-allowed disabled:opacity-60',
      !disabled && 'cursor-pointer hover:bg-slate-50',
    )}
  >
    <span
      className={cn(
        'inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full',
        danger ? 'bg-red-50 text-red-600' : 'bg-brand-50 text-brand-600',
      )}
    >
      {icon}
    </span>
    <span className={cn('min-w-0 flex-1 truncate text-sm font-medium', danger ? 'text-red-600' : 'text-ink')}>
      {label}
    </span>
    {value && <span className="shrink-0 text-sm text-ink-muted">{value}</span>}
    {trailing}
    {showChevron && !danger && (
      <ChevronRightIcon className="h-4 w-4 shrink-0 text-ink-faint" aria-hidden />
    )}
  </button>
);
